<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: huliekao
 * @Date: 2021-07-13 15:50:25
 * @LastEditors: Seven
 * @LastEditTime: 2021-10-27 11:19:35
-->
<template>
  <span>
    <el-button type="success" class="hq-button" :disabled="code==='telephone'&&tableData.length==0" @click="exportClick" icon="el-icon-download">导出</el-button>
    <!-- 导出 -->
    <HqModal :visible="exportModel" title="导出" @on-cancel="cancel">
      <div style="text-align: center">{{ message }}</div>
      <template #footer>
        <el-button
          v-if="!down"
          type="primary"
          @click="exportCustomer()"
          :loading="exportloading"
          >确定</el-button
        >
        <a :href="url" v-else>
          <el-button
            type="success"
            @click="cancel"
            >点击下载</el-button
          >
        </a>
        <el-button
          type="error"
          @click="cancel"
          style="margin-left: 8px"
          >取消</el-button
        >
      </template>
    </HqModal>
  </span>
</template>
<script>
import { doExportCustomer, doInvalidExport, doRecomendCustomerExport, doExportCall, doAppointmentExport } from "api/customer";
export default {
  name: "export",
  props: {
    pageParam: {
      type: Object,
    },
    searchParam: {
      type: Object,
    },
    total: {
      type: Number,
    },
    exportType: {
      type: Number,
    },
    code: {
      type: String,
    },
    tableData: {
      type: Array
    }
  },
  data() {
    return {
      exportModel: false,
      exportloading: false,
      down: false,
      url: "",
      message: "您要将这些商机导出吗？"
    }
  },
  methods: {
    exportClick() {
      if(this.code === "inspect" && !this.searchParam.beginCreateTime) {
        this.$message.error("请选择 '无效时间' 后再导出")
        return false
      }
      this.exportModel = true
    },
    // 导出
    async exportCustomer() {
      this.exportloading = true
      this.message = "正在为你打包商机，请稍等！"
      let res;
      if(this.code === "inspect") {
        res = await doInvalidExport({...this.pageParam, ...this.searchParam, ...{total: this.total}})
      } else if(this.code === "introduce") {
        res = await doRecomendCustomerExport({...this.pageParam, ...this.searchParam, ...{total: this.total}})
      } else if(this.code === "appointment") {
        res = await doAppointmentExport({...this.pageParam, ...this.searchParam, ...{total: this.total}})
      } else if(this.code === "telephone") {
        res = await doExportCall({...this.pageParam, ...this.searchParam, ...{total: this.total}})
      } else {
        res = await doExportCustomer({...this.pageParam, ...this.searchParam, ...{exportType: this.exportType, total: this.total}})
      }
      if(res.code === 0) {
        this.message = "商机已经打包完毕，请点击下载！"
        this.url = res.result
        this.exportloading = false
        this.down = true
      } else {
        this.$message.error(res.msg)
        this.exportloading = false
      }
    },
    cancel() {
      this.exportModel = false
      this.exportloading = false
      this.down = false
      this.url = ""
      this.message = "您要将这些商机导出吗？"
    }
  },
};
</script>
